import React, { Component } from 'react';
import { connect } from "react-redux";
import { compose } from "redux";
import Footer from '../components/Footer';
import Header from '../components/Header';
import axios from 'axios';
import { setLanguageName, setSchool, setClassName, setClassId, setLanguageId } from "../modules/actions";
import { getHasUniformCatalog } from "../modules/reducers";
import { BASEURL } from '../Config';

class Shop extends Component {
    constructor(props) {
        super(props);
        this.state = {
            school: {},
            classes: [],
            loading: true
        }
    }
    componentDidMount() {
        axios.post(`${BASEURL}/api/v1/schools/fetchByName`, { name: this.props.match.params.sname })
            .then(res => {
                if (res.status === 200) {
                    this.props.setSchool(res.data);
                    this.setState({
                        school: res.data
                    }, () => {
                        let input = {};
                        input.sname = this.state.school.name;
                        input.state = this.state.school.state;
                        input.stype = this.state.school.type;
                        axios.post(`${BASEURL}/api/v1/classes/fetch`, input)
                            .then(res => {
                                if (res.status === 200 && res.data.data.classesLanguages.length > 0) {
                                    const filteredClasses = res.data.data.classesLanguages.filter(classItem => classItem.languages.length > 0);
                                    this.setState({
                                        classes: filteredClasses,
                                        loading: false
                                    });
                                } else {
                                    this.setState({ loading: false });
                                }
                            })
                            .catch(err => {
                                console.log(err);
                                this.setState({ loading: false });
                            })
                    })
                }
            })
            .catch(err => {
                console.log(err);
                this.setState({ loading: false });
            })

    }

    handleSelectLanguage(cname, lname, classId, langId) {
        this.props.setClassName(cname);
        this.props.setLanguageName(lname);
        this.props.setClassId(classId);
        this.props.setLanguageId(langId);
        window.location.href = 'schoolProducts';
    }

    render() {
        const { school, classes, loading } = this.state;
        const isSchoolInactive = school && school.isActive === false;

        return (
            <div className="site-wrap">
                <Header page={'shop'} />
                <div className="site-section">
                    <div className="container">
                        {loading ? (
                            <div className="row mb-5">
                                <div className="col-12 text-center">
                                    <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
                                        <span className="sr-only">Loading...</span>
                                    </div>
                                    <p className="mt-3">Loading classes...</p>
                                </div>
                            </div>
                        ) : (
                            <>
                            {isSchoolInactive ? (
                            <div className="row mb-5">
                                <div className="col-12">
                                    <div className="alert alert-secondary text-center" role="alert">
                                        <h4 className="alert-heading">School Currently Unavailable</h4>
                                        <p className="mb-0">Currently we are not taking any orders for this school. Please check back later.</p>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <>
                            {this.props.hasUniformCatalog && (
                            <div className="row mb-4">
                                <div className="col-12">
                                    <div className="card shadow-sm border-0" style={{ background: '#f8f9fc' }}>
                                        <div className="card-body d-flex align-items-center justify-content-between flex-wrap py-3">
                                            <div>
                                                <h6 className="mb-1 font-weight-bold">Order Uniform Products</h6>
                                                <p className="mb-0 text-muted small">Choose class, gender and select sizes.</p>
                                            </div>
                                            <button
                                                className="btn btn-primary mt-2 mt-md-0"
                                                onClick={() => window.location.href = 'uniformOrder'}
                                            >
                                                Order Uniforms
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            )}
                            <div className="row mb-5">
                                {classes.length > 0 ?
                                    <>
                                        {classes.map((item, index) => {
                                            return (
                                                <div className='col-md-3 mb-3' key={index}>
                                                    <div className='card classCards shadow'>
                                                        <div className='card-body mb-3'>
                                                            <h4 className='card-title text-center'>{item.className}</h4>
                                                            {item.languages.length > 0 ?
                                                                <table className='table text-center table-bordered classTable'>
                                                                    <thead className='thead'>
                                                                        <th>Select Language</th>
                                                                    </thead>
                                                                    <tbody className='tbody'>
                                                                        {item.languages.map((item1, index1) => (
                                                                            <tr key={index1}>
                                                                                <td>
                                                                                    <a onClick={() => this.handleSelectLanguage(item.className, item1.lname, item._id, item1._id)}>{item1.lname}</a>
                                                                                </td>
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                </table>
                                                                :
                                                                <div className="alert alert-primary text-center mt-2" role="alert">
                                                                    <small>No products available for this class</small>
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </>
                                    :
                                    !this.props.hasUniformCatalog ? (
                                        <div className="col-12">
                                            <div className="alert alert-primary text-center" role="alert">
                                                <h5 className="alert-heading">No Classes Available</h5>
                                                <p className="mb-0">Classes are not available for this school at the moment.</p>
                                            </div>
                                        </div>
                                    ) : null
                                }
                            </div>
                            </>
                        )}
                            </>
                        )}
                    </div>
                </div>
                <Footer />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    hasUniformCatalog: getHasUniformCatalog(state),
})

const mapDispatchToProps = dispatch => ({
    setSchool: (school) => dispatch(setSchool(school)),
    setClassName: (className) => dispatch(setClassName(className)),
    setLanguageName: (lname) => dispatch(setLanguageName(lname)),
    setClassId: (classId) => dispatch(setClassId(classId)),
    setLanguageId: (langId) => dispatch(setLanguageId(langId))
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(Shop);